import { isEqual } from 'lodash';
import { useContext } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { AppContext } from './AppContext';
export const useAppContext = (selector) => {
    const store = useContext(AppContext);
    if (!store)
        throw new Error('Missing AppProvider in the tree');
    return useStoreWithEqualityFn(store, selector, isEqual);
};
